"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function LaunchController(
  $rootScope,
  $scope,
  $log,
  openFinApi,
  RediWindowService,
  rediTokenService,
  openFinWebAuthenticator,
  openFinWebClientInitializer,
  windowInitParamsRepository,
  menuItemRepository,
  RediWindowRepository,
  rediPlusWorkspaceService,
  OpenfinWindowFactory,
  rediPlusWindowService,
  rediPlusLifeCycleManager
) {
  var that = this;
  that.messages = [];
  that.messageTypes = {
    OPEN_WINDOW_MSG_TYPE: "open-window",
    WINDOW_COMMAND_MSG_TYPE: "window-command",
    OPEN_WORKSPACE: "open-workspace",
    CLOSE_WORKSPACE: "close-workspace",
    SAVE_WORKSPACE: "save-workspace",
    CLOSE_SESSION: "close-session",
    REDI_PLUS_WINDOW_OPENED: "rediplus-window-opened",
    REDI_PLUS_WINDOW_CLOSED: "rediplus-window-closed",
    REGISTER_LINK: "register-link",
    UNREGISTER_LINK: "unregister-link",
    CONTEXT_CHANGED: "context-changed",
    CREATE_SPREAD_FROM_TICKETS: "create-spread-from-tickets",
    RELOGIN_TO_WORKSPACE: "relogin",
    DEBUG_ESO: "debug-eso"
  };

  (function() {
    openFinApi.subscribe(
      "*",
      that.messageTypes.OPEN_WINDOW_MSG_TYPE,
      _.partial(rediPlusMessageHandler, that.messageTypes.OPEN_WINDOW_MSG_TYPE)
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.WINDOW_COMMAND_MSG_TYPE,
      _.partial(
        rediPlusMessageHandler,
        that.messageTypes.WINDOW_COMMAND_MSG_TYPE
      )
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.SPREADTRADER_API_TYPE,
      _.partial(rediPlusMessageHandler, that.messageTypes.SPREADTRADER_API_TYPE)
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.CLOSE_SESSION,
      _.partial(rediPlusMessageHandler, that.messageTypes.CLOSE_SESSION)
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.REDI_PLUS_WINDOW_OPENED,
      _.partial(
        rediPlusMessageHandler,
        that.messageTypes.REDI_PLUS_WINDOW_OPENED
      )
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.REDI_PLUS_WINDOW_CLOSED,
      _.partial(
        rediPlusMessageHandler,
        that.messageTypes.REDI_PLUS_WINDOW_CLOSED
      )
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.REGISTER_LINK,
      _.partial(rediPlusMessageHandler, that.messageTypes.REGISTER_LINK)
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.UNREGISTER_LINK,
      _.partial(rediPlusMessageHandler, that.messageTypes.UNREGISTER_LINK)
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.CONTEXT_CHANGED,
      _.partial(rediPlusMessageHandler, that.messageTypes.CONTEXT_CHANGED)
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.OPEN_WORKSPACE,
      _.partial(workspaceMessageHandler, that.messageTypes.OPEN_WORKSPACE)
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.CLOSE_WORKSPACE,
      _.partial(workspaceMessageHandler, that.messageTypes.CLOSE_WORKSPACE)
    );
    openFinApi.subscribe(
      "*",
      that.messageTypes.SAVE_WORKSPACE,
      _.partial(workspaceMessageHandler, that.messageTypes.SAVE_WORKSPACE)
    );

    openFinApi.subscribe(
      "*",
      that.messageTypes.CREATE_SPREAD_FROM_TICKETS,
      _.partial(
        rediPlusMessageHandler,
        that.messageTypes.CREATE_SPREAD_FROM_TICKETS
      )
    );

    openFinApi.subscribe(
      "*",
      that.messageTypes.RELOGIN_TO_WORKSPACE,
      _.partial(rediPlusMessageHandler, that.messageTypes.RELOGIN_TO_WORKSPACE)
    );

    openFinApi.subscribe(
      "*",
      that.messageTypes.DEBUG_ESO,
      _.partial(rediPlusMessageHandler, that.messageTypes.DEBUG_ESO)
    );

    windowInitParamsRepository.get().then(function(initParams) {
      openFinWebClientInitializer.initialize(initParams);
    });
  })();

  function rediPlusMessageHandler(type, message, senderUuid) {
    openFinWebClientInitializer.isInitialized().finally(function() {
      openFinWebAuthenticator.authenticate(message).then(function() {
        handleRediPlusMessage(type, message, senderUuid);
      });
    });
  }

  function handleRediPlusMessage(type, message, senderUuid) {
    switch (type) {
      case that.messageTypes.OPEN_WINDOW_MSG_TYPE:
        handleOpenWindowMessage(message);
        break;
      case that.messageTypes.WINDOW_COMMAND_MSG_TYPE:
        handleWindowCommandMessage(message);
        break;
      case that.messageTypes.CLOSE_SESSION:
        handleCloseSessionMessage(message);
        break;
      case that.messageTypes.REDI_PLUS_WINDOW_OPENED:
        rediPlusWindowService.handleWindowOpenedEvent(message);
        break;
      case that.messageTypes.REDI_PLUS_WINDOW_CLOSED:
        rediPlusWindowService.handleWindowClosedEvent(message);
        break;
      case that.messageTypes.REGISTER_LINK:
        rediPlusWindowService.handleRegisterLink(
          message.sourceWindowId,
          message.targetNativeWindowId
        );
        break;
      case that.messageTypes.UNREGISTER_LINK:
        rediPlusWindowService.handleUnregisterLink(
          message.sourceWindowId,
          message.targetNativeWindowId
        );
        break;
      case that.messageTypes.CONTEXT_CHANGED:
        rediPlusWindowService.handleContextChanged(
          message.data,
          message.sourceWindowId
        );
        break;
      case that.messageTypes.CREATE_SPREAD_FROM_TICKETS:
        handleCreateSpreadFromTicketsWindowMessage(message);
        break;
      case that.messageTypes.RELOGIN_TO_WORKSPACE:
        openFinWebClientInitializer.relogin();
        break;
      case that.messageTypes.DEBUG_ESO:
        openFinWebClientInitializer.triggerFakeESO();
        break;
    }
    var data =
      "Received window message with data: " +
      message.data +
      " from sender: " +
      senderUuid;
    that.messages.push({ data: data });
  }

  function handleCreateSpreadFromTicketsWindowMessage(message) {
    const spreadBlotter = "blotter";
    const isSpreadTraderOpen = RediWindowRepository.getWindowsByType(
      spreadBlotter
    ).length;
    if (!isSpreadTraderOpen) {
      openFinApi.publish(that.messageTypes.OPEN_WINDOW_MSG_TYPE, {
        data: "SpreadTrader",
        params: message
      });
    }
  }

  function handleCloseSessionMessage(message) {
    var signOut = _.get(message, "signOut", true);
    rediPlusLifeCycleManager.stop(!signOut);

    var publishMenuItems = _.get(message, "refreshMenuItems", false);
    if (publishMenuItems) {
      openFinWebClientInitializer.publishMenuItemsOnEikonSessionClose();
    }
  }

  function handleOpenWindowMessage(message) {
    var messageData = message.data;
    var windowName;
    var params;
    if (_.isObject(messageData)) {
      windowName = messageData.windowName;
      params = messageData;
    } else {
      windowName = messageData;
      params = message.params;
    }

    menuItemRepository
      .getByName(windowName, params)
      .then(function(menuItem) {
        return RediWindowService.createRediWindowFromMenuItem(menuItem, params);
      })
      .then(undefined, function(error) {
        return OpenfinWindowFactory.createAndShowErrorWindow(
          "App Launch Error",
          (error && error.message) ||
            "An unexpected error occurred while launching " + windowName
        );
      });
  }

  function handleWindowCommandMessage(message) {
    OpenfinWindowFactory.executeOnOpenWindows(message.data, function() {
      $log.debug("Executed window command: " + message.data);
    });
  }

  function invokeForNonEmptyMessageData(
    workspaceName,
    type,
    handler,
    workspaceOwner
  ) {
    if (!workspaceName) {
      $log.debug(
        "For workspace message of type: " +
          type +
          " workspaceName is empty, ignoring the message"
      );
      return;
    }
    handler(workspaceName, workspaceOwner);
  }

  function handleWorkspaceMessage(type, message, senderUuid) {
    var data =
      "Received workspace message: " + message.data + " from " + senderUuid;
    $log.debug(data);
    that.messages.push({ data: data });
    switch (type) {
      case that.messageTypes.OPEN_WORKSPACE:
        invokeForNonEmptyMessageData(
          message.data,
          type,
          rediPlusWorkspaceService.open,
          message.workspace_owner
        );
        break;
      case that.messageTypes.SAVE_WORKSPACE:
        invokeForNonEmptyMessageData(
          message.data,
          type,
          rediPlusWorkspaceService.save
        );
        break;
      case that.messageTypes.CLOSE_WORKSPACE:
        rediPlusWorkspaceService.close();
        break;
    }
  }

  function workspaceMessageHandler(type, message, senderUuid) {
    openFinWebClientInitializer.isInitialized().finally(function() {
      openFinWebAuthenticator.authenticate(message).then(function() {
        handleWorkspaceMessage(type, message, senderUuid);
      });
    });
  }

  $rootScope.$on("event:auth-loginRequired", rediTokenService.refreshTokens);
};



// WEBPACK FOOTER //
// ./app/presentation/controllers/LaunchController.js